<script setup>
    import { ref, onMounted, watch, getCurrentInstance } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import adminJobfairService from "../../services/jobfair/adminJobfairService";
    import _ from 'lodash'
    import fileService from "../../../../services/fileService";
    import { useAlertStore } from '../../../../stores/alertStore';
    const { $alert } = useAlertStore();
    const { $toast, $number } = getCurrentInstance().appContext.config.globalProperties;

    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore();
    const loaded = ref(false); // 데이터 받고 난 후, 화면 그리는 용도

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            router.push({name: 'OjfList'})
        } else {
            retrieveOnlineJobFair(id)
        }
    })

    const editorRef = ref(null)

    const input = ref({
        ojfId: 0,        // 온라인채용박람회아이디
        ojfStateGb: "00",// 온라인채용박람회 진행상태 00 신청 대기 01 신청 접수중 02 신청 마감 03 행사 진행중 04 행사 종료 05 행사 중단
        ojfName: "",     // 행사명
        regStartYmd: "", // 접수시작일자
        regEndYmd: "",   // 접수종료일자
        ojfStartYmd: "", // 행사시작일자
        ojfEndYmd: "",   // 행사종료일자
        ojfPlace: "",    // 장소
        ojfHost: "",     // 주최
        ojfIntro: "",    // 행사소개
        ojfThombName: "",// 썸네일명
        ojfThombSize: "",// 썸네일용량
        ojfThombDir: "", // 썸네일위치
        summary: "",     // 간략안내
        openYn: "Y",      // 공개여부
        ojfGb: "01",     // 행사구분
    })

    const inputError = ref({
        ojfName: '',
        regYmd: '',
        ojfYmd: '',
        ojfPlace: '',
        ojfHost: '',
        ojfIntro: '',
        ojfThombName: '',
        summary: '',
    })

    // 행사 정보 조회
    const retrieveOnlineJobFair = (id) => {
        loadingStore.loading = true;
        loaded.value = false; // 데이터 받기 전에 화면 안 그리기
        adminJobfairService.retrieveOnlineJobFair(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    input.value = result;
                    // 행사 소개 CK-Editor 데이터 셋팅
                    if(input.value.ojfIntro) {
                        setTimeout(()=>{
                            editorRef.value.init(input.value.ojfIntro);
                        }, 100)
                    }
                    loaded.value = true; // 데이터 받고 나서 화면 그리기
                }
            }).catch( (error) =>  {
                loadingStore.loading = false;
            $toast("error", error);
        });
    }

    // 썸네일 이미지 등록
    const uploadThumbFile = (type) => {
        const fileInput = document.createElement('input');
        fileInput.type= 'file';
        fileInput.click();

        fileInput.addEventListener('change', function(event){
            const file = event.target.files[0];

            let paramObj = {
                container: 'public',
                folder: 'jobfair',
                file,
            }
            fileService.uploadFile(paramObj)
                .then((res) => {
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        if(type === 'thumb') {
                            input.value.ojfThombName = result.originalFilename;
                            input.value.ojfThombSize = result.fileSize;
                            input.value.ojfThombDir = result.blobUrl;
                        }
                    }
                })
                .catch( (error) =>  {
                    $toast("error", error);
                });
        });
    }

    // 썸네일 이미지 삭제
    const removeThumbFile = (type) => {
        if(type === 'thumb') {
            input.value.ojfThombName = '';
            input.value.ojfThombSize = '';
            input.value.ojfThombDir = '';
        }
    }

    // 행사 등록
    const update = () => {
        const request = _.cloneDeep(input.value);
        const {
            ojfId,       // 온라인채용박람회아이디
            ojfStateGb,  // 온라인채용박람회 진행상태
            ojfName,     // 행사명
            regStartYmd, // 접수시작일자
            regEndYmd,   // 접수종료일자
            ojfStartYmd, // 행사시작일자
            ojfEndYmd,   // 행사종료일자
            ojfIntvDay,  // 면접기간
            ojfPlace,    // 장소
            ojfHost,     // 주최
            ojfIntro,    // 행사소개
            ojfThombName,// 썸네일명
            ojfThombSize,// 썸네일용량
            ojfThombDir, // 썸네일위치
            summary,     // 간략안내
            openYn,       // openYn
            ojfGb        // 행사구분
        } = request;
        let isInvalid = false;

        inputError.value = {};
        if(!ojfName) {
            $alert(["행사명을 입력하세요"]);
            isInvalid = true;
            return false;
        }
        if( !validateKEN50(ojfName) ) {
            $alert(["행사명은 한글 또는 영문, 숫자로만 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if( !regStartYmd || !regEndYmd ){
            $alert(["접수기간을 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if( !ojfStartYmd || !ojfEndYmd ){
            $alert(["행사기간을 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if( regEndYmd > ojfEndYmd ){
            $alert(["접수종료일은 행사종료일보다 빨라야합니다."]);
            isInvalid = true;
            return false;
        }
        if( regStartYmd > ojfEndYmd ){
            $alert(["접수시작일은 행사종료일보다 빨라야합니다."]);
            isInvalid = true;
            return false;
        }
        if( !ojfIntvDay ){
            $alert(["면접기간을 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if(!ojfPlace) {
            $alert(["장소를 입력하세요."]);
            isInvalid = true;
            return false;
        }
        // 20250926(ella) - 한글,영문,숫자,기호 입력 가능 요청
        // if( !validateKEN50(ojfPlace) ) {
        //     $alert(["장소는 한글 또는 영문, 숫자로만 입력하세요."]);
        //     isInvalid = true;
        //     return false;
        // }
        if (!ojfHost) {
            $alert(["주최를 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if( !validateKEN50(ojfHost) ) {
            $alert(["주최는 한글 또는 영문, 숫자로만 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if(!ojfIntro) {
            $alert(["행사 소개를 입력하세요."]);
            isInvalid = true;
            return false;
        }
        if(!ojfThombName) {
            $alert(["썸네일 이미지를 선택하세요."]);
            isInvalid = true;
            return false;
        }
        if(ojfThombSize > 209715200) {
            $alert(["첨부 가능한 용량을 확인하세요."]);
            isInvalid = true;
            return false;
        }
        if(!summary) {
            $alert(["간략 안내 문구를 입력하세요."]);
            isInvalid = true;
            return false;
        }
/*
        if( !validateKEN200(summary) ) {
            $alert(["안내 문구는 한글 또는 영문, 숫자로만 입력하세요."]);
            isInvalid = true;
            return false;
        }
*/

        if(!isInvalid) {
            loadingStore.loading = true;
            adminJobfairService.updateOnlineJobFair(request)
                .then( async (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        const ok = await $alert([ "변경사항을 저장했습니다."]);
                        if(ok) {
                            goBack();
                        }
                    } else {
                        $alert(["행사 수정을 실패하였습니다."]);
                    }
                }).catch( (res) =>  {
                    loadingStore.loading = false;
                    $toast("error", res.response.data.result.message);
                });
        }
    }

    // 행사상세로 돌아가기
    const goBack = () => {
        router.push({name: 'OjfDetail', params: {id: input.value.ojfId}});
    }

    // 한글, 영문, 숫자로만 이루어져있으며 50자를 넘기지 않는지 확인
    const validateKEN50 = (text) => {
        const regex = /^[A-Za-z0-9가-힣\s]{1,50}$/;
        return regex.test(text);
    }

    // 한글, 영문, 숫자로만 이루어져있으며 200자를 넘기지 않는지 확인
    const validateKEN200 = (text) => {
        const regex = /^[A-Za-z0-9가-힣\s]{1,200}$/;
        return regex.test(text);
    }
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>행사 수정</h3>
            <p><span>* 표시는 필수 입력사항</span> 입니다.</p>
        </div>
        <div v-if="loaded" class="table-form">
            <table class="vertical">
                <colgroup>
                    <col width="200px" />
                    <col />
                </colgroup>
                <tr>
                    <th class="mark">행사구분</th>
                    <td>
                        <KSARadioButton class="mr-md" name="ojfGb" label="기업공채관" v-model="input.ojfGb" value="01" />
                        <KSARadioButton class="mr-md" name="ojfGb" label="채용박람회" v-model="input.ojfGb" value="02" />
                    </td>
                </tr>
                <tr>
                    <th class="mark">행사명</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.ojfName" :msg="inputError.ojfName" max-length="50" placeholder="행사명을 50자 이내로 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">접수기간</th>
                    <td class="text-box">
                        <div style="display: inline-block;">
                            <KSADatepickerTerms
                                :startDate="input.regStartYmd"
                                :endDate="input.regEndYmd"
                                @update:startDate="(value)=> input.regStartYmd = value"
                                @update:endDate="(value)=> input.regEndYmd = value"
                            />
                        </div>
                        <div>
                            <small style="color:#E71414;">{{ inputError.regYmd }}</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="mark">행사기간</th>
                    <td class="text-box">
                        <div style="display: inline-block;">
                            <KSADatepickerTerms
                                :startDate="input.ojfStartYmd"
                                :endDate="input.ojfEndYmd"
                                @update:startDate="(value)=> input.ojfStartYmd = value"
                                @update:endDate="(value)=> input.ojfEndYmd = value"
                            />
                        </div>
                        <div>
                            <small style="color:#E71414;">{{ inputError.ojfYmd }}</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="mark">면접기간</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.ojfIntvDay" max-length="2000" placeholder="면접 가능기간 또는 가능일을 2000자 이내로 입력해주세요.  ex) 9/1, 9/3, 9/5" />
                    </td>
                </tr>
                <tr>
                    <th class="mark">장소</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.ojfPlace" :msg="inputError.ojfPlace" max-length="50" placeholder="행사 장소 정보를 50자 이내로 입력해주세요.  ex) 한국반도체아카데미 홈페이지, 대면(협회본관3층) 등"/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">주최</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.ojfHost" :msg="inputError.ojfHost" max-length="50" placeholder="주최 정보를 50자 이내로 입력해주세요.  ex) 한국반도체산업협회"/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">행사 소개</th>
                    <td>
                        <KSACKEditor ref="editorRef" v-model="input.ojfIntro" container="public"/>
                        <div>
                            <small style="color:#E71414;">{{ inputError.ojfIntro }}</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th><span class="mark">썸네일 이미지</span><br><span>(목록+상세 출력)</span></th>
                    <td class="text-box">
                        <div class="grid file">
                            <KSAPrimaryButton text="파일 선택" @click="uploadThumbFile('thumb')" />
                            <KSAInput class="input icon" placeholder="파일 선택(398px X 284px 사이즈 이미지를 권장합니다.)" v-model="input.ojfThombName" disabled />
                            <button class="delete" :disabled="!input.ojfThombName" @click="removeThumbFile('thumb')"><i></i></button>
                        </div>
                        <small>최대 200MB 까지 첨부 가능</small>
                        <div>
                            <small style="color:#E71414;">{{ inputError.ojfThombName }}</small>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th><span class="mark">간략 안내</span><br><span>(상세 출력)</span></th>
                    <td>
                        <KSAInput class="text-box" v-model="input.summary" :msg="inputError.summary" max-length="200" placeholder="행사에 대한 설명 또는 참고사항을 200자 이내로 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">공개/비공개 설정</th>
                    <td>
                        <KSARadioButton class="mr-md" name="openYn" label="공개" v-model="input.openYn" value="Y" />
                        <KSARadioButton class="mr-md" name="openYn" label="비공개" v-model="input.openYn" value="N" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="btn-wrap space-between">
            <KSASecondaryButton class="gray_button" text="취소" @click="goBack" />
            <KSAPrimaryButton text="수정" @click="update" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

</style>